import ConnectedVehicle from 'src/components/ConnectedVehicle/ConnectedVehicle';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { ConnectedVehicleActionCreator } from 'src/store/states';

const mapStateToProps = (state: IStoreState) => ({
    connectedVehicle: state.ConnectedVehicle.ConnectedVehicleRec,
    checkedDtc: state.ConnectedVehicle.CheckedDTC,
    importedDtc: state.ConnectedVehicle.ImportedDTC,
    checkedRecommended: state.ConnectedVehicle.CheckedRecommended,
    importedRecommended: state.ConnectedVehicle.ImportedRecommended,
    checkedCampaign: state.ConnectedVehicle.CheckedCampaign,
    importedCampaign: state.ConnectedVehicle.ImportedCampaign,
    mode: state.Framework.specProfile,
    docType: state.Framework.docType,
    rcardAvailFlag: state.Framework.rcardAvailFlag,
});

const mapDispatchToProps = {
    getConnectedVehicle: ConnectedVehicleActionCreator.GetConnectedVehicle,
    reloadConnectedVehicle: ConnectedVehicleActionCreator.ReloadConnectedVehicle,
    clearConnectedVehicle: ConnectedVehicleActionCreator.ClearConnectedVehicle,
    printConnectedVehicle: ConnectedVehicleActionCreator.PrintConnectedVehicle,
    invokeConnectedVehicle: ConnectedVehicleActionCreator.InvokeConnectedVehicle,
    toggleAllDtc: ConnectedVehicleActionCreator.ToggleAllDtc,
    toggleAllCampaign: ConnectedVehicleActionCreator.ToggleAllCampaign,
    toggleAllRecommended: ConnectedVehicleActionCreator.ToggleAllRecommended,
    importDtc: ConnectedVehicleActionCreator.ImportDtc,
    importRecommended: ConnectedVehicleActionCreator.ImportRecommended,
    importCampaign: ConnectedVehicleActionCreator.ImportCampaign,
    importTirePressure: ConnectedVehicleActionCreator.ImportTirePressure,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedVehicle);